import type { Brand, Category, Device, Product, Wilaya } from '@/models';
import {
  brandRepository,
  categoryRepository,
  deviceRepository,
  productRepository,
  wilayaRepository,
} from '@/repositories';

export function listBrands(): Promise<Brand[]> {
  return brandRepository.list();
}

export function getBrandBySlug(slug: string): Promise<Brand | null> {
  return brandRepository.findBySlug(slug);
}

export function listProducts(brandSlug: string | null = null): Promise<Product[]> {
  return productRepository
    .list()
    .then((products) =>
      brandSlug ? products.filter((product) => product.brandSlug === brandSlug) : products
    );
}

export function getProductBySlug(slug: string): Promise<Product | null> {
  return productRepository.findBySlug(slug);
}

export async function getFeaturedProducts(limit?: number): Promise<Product[]> {
  const featured = (await productRepository.list()).filter((product) => product.isFeatured);
  return typeof limit === 'number' ? featured.slice(0, limit) : featured;
}

export function listWilayas(): Wilaya[] {
  return wilayaRepository.list();
}

export function listCategories(): Promise<Category[]> {
  return categoryRepository.list();
}

export function listDevices(): Promise<Device[]> {
  return deviceRepository.list();
}

export function getDeviceBySlug(slug: string): Promise<Device | null> {
  return deviceRepository.findBySlug(slug);
}

export async function listDevicesForBrand(brandSlug: string): Promise<Device[]> {
  const brand = await brandRepository.findBySlug(brandSlug);
  if (!brand?.id) {
    return [];
  }
  const devices = await deviceRepository.list();
  return devices.filter((device) => device.brandId === brand.id);
}

export function listCompatibleDevices(productId: string): Promise<Device[]> {
  return deviceRepository.listForProduct(productId);
}

export async function listCompatibleProducts(deviceId: string): Promise<Product[]> {
  const ids = await deviceRepository.listCompatibleProductIds(deviceId);
  if (ids.length === 0) {
    return [];
  }
  const products = await productRepository.list();
  return products.filter((product) => ids.includes(product.id));
}
